const doc = [({"ko":({"adminConstantAdminUserStatus":({"disabled":"유효", "enabled":"유효", "invited":"초대 된"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;